module.exports = __webpack_public_path__ + "img/Szekely_Tibor_2026.caa3ec7b.jpg";